(function () {
  var root = document.documentElement;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var isSafari =
    /Safari/i.test(navigator.userAgent) &&
    !/(Chrome|Chromium|CriOS|Edg|EdgiOS|OPR|FxiOS|Android)/i.test(navigator.userAgent);

  root.classList.add("fis-js");

  function easeOutCubic(progress) {
    return 1 - Math.pow(1 - progress, 3);
  }

  function setRevealDelays(section) {
    var items = section.querySelectorAll("[data-fis-reveal]");

    items.forEach(function (item, index) {
      item.style.setProperty("--fis-delay", Math.min(index * 110, 440) + "ms");
    });
  }

  function animateDonut(donut) {
    if (donut.dataset.fisAnimated === "true") {
      return;
    }

    donut.dataset.fisAnimated = "true";

    var target = Math.max(0, Math.min(100, Number(donut.dataset.fisPercent) || 0));
    var progressCircle = donut.querySelector(".fis-donut__progress");
    var valueNode = donut.querySelector("[data-fis-value]");
    var circumference = 440;
    var duration = 1250;
    var startDelay = 160;
    var startTime = null;
    var lastDisplayedValue = -1;

    if (!progressCircle || reduceMotion) {
      if (progressCircle) {
        progressCircle.style.strokeDashoffset = circumference - (circumference * target) / 100;
      }

      if (valueNode) {
        valueNode.textContent = Math.round(target);
      }

      return;
    }

    function frame(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var eased = easeOutCubic(progress);
      var current = target * eased;

      if (!isSafari) {
        progressCircle.style.strokeDashoffset = circumference - (circumference * current) / 100;
      }

      var displayedValue = Math.round(current);

      if (valueNode && displayedValue !== lastDisplayedValue) {
        valueNode.textContent = displayedValue;
        lastDisplayedValue = displayedValue;
      }

      if (progress < 1) {
        window.requestAnimationFrame(frame);
      }
    }

    if (valueNode) {
      valueNode.textContent = "0";
    }

    progressCircle.style.strokeDashoffset = circumference;
    window.setTimeout(function () {
      if (isSafari) {
        progressCircle.style.transition =
          "stroke-dashoffset 1050ms cubic-bezier(0.22, 1, 0.36, 1), stroke-width 220ms ease";
        progressCircle.style.strokeDashoffset = circumference - (circumference * target) / 100;
      }

      window.requestAnimationFrame(frame);
    }, startDelay);
  }

  function initDonutTilt(section) {
    var canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    if (reduceMotion || !canHover) {
      return;
    }

    section.querySelectorAll(".fis-donut").forEach(function (wrap) {
      if (wrap.dataset.fisTiltInitialized === "true") {
        return;
      }

      var scene = wrap.querySelector(".fis-donut__scene");

      if (!scene) {
        return;
      }

      var rect = null;
      var pointerX = 0;
      var pointerY = 0;
      var tiltFrame = null;
      var maxTilt = isSafari ? 11 : 18;
      var hoverScale = isSafari ? 1.035 : 1.08;

      function renderTilt() {
        tiltFrame = null;

        if (!rect) {
          return;
        }

        var centerX = rect.left + rect.width / 2;
        var centerY = rect.top + rect.height / 2;
        var deltaX = Math.max(-1, Math.min(1, (pointerX - centerX) / (rect.width / 2)));
        var deltaY = Math.max(-1, Math.min(1, (pointerY - centerY) / (rect.height / 2)));

        scene.style.transform =
          "rotateX(" + (-deltaY * maxTilt) + "deg) rotateY(" + (deltaX * maxTilt) + "deg) scale(" + hoverScale + ")";
      }

      wrap.dataset.fisTiltInitialized = "true";

      wrap.addEventListener("mouseenter", function () {
        rect = wrap.getBoundingClientRect();
        scene.style.transition = "none";
      });

      wrap.addEventListener(
        "mousemove",
        function (event) {
          pointerX = event.clientX;
          pointerY = event.clientY;

          if (tiltFrame === null) {
            tiltFrame = window.requestAnimationFrame(renderTilt);
          }
        },
        { passive: true }
      );

      wrap.addEventListener("mouseleave", function () {
        if (tiltFrame !== null) {
          window.cancelAnimationFrame(tiltFrame);
          tiltFrame = null;
        }

        rect = null;
        scene.style.transform = "";
        scene.style.transition = "";
      });
    });
  }

  function revealItem(item) {
    item.classList.add("fis-is-visible");

    if (item.matches("[data-fis-donut]")) {
      animateDonut(item);
    }

    item.querySelectorAll("[data-fis-donut]").forEach(animateDonut);
  }

  function initReveal(section) {
    var revealItems = section.querySelectorAll("[data-fis-reveal]");

    setRevealDelays(section);

    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealItems.forEach(revealItem);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          revealItem(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    revealItems.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.fisInitialized === "true") {
      return;
    }

    section.dataset.fisInitialized = "true";

    if (isSafari) {
      section.classList.add("fis-safari");
    }

    initDonutTilt(section);
    initReveal(section);
  }

  function initAll() {
    document.querySelectorAll("[data-fis-section]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target.querySelector("[data-fis-section]"));
  });
})();
